import { fetchWithChatFeedback } from './chatFeedbackRequired';
/**
 * App-shell-only resolver for direct similar-requirements navigation.
 *
 * Home Chat receives and renders only opaque handles. This function is called
 * by App after its modal closes; its raw flow ID return value is transient and
 * must be immediately passed into App's existing generic flow selector.
 */
const BASE_URL = process.env.REACT_APP_API_URL || '';
const RESOLVE_URL = '/api/home-chat/similar-requirements/navigation/resolve';

export async function resolveHomeChatNavigation(navigationHandle: string): Promise<string> {
  try {
    const response = await fetchWithChatFeedback(`${BASE_URL}${RESOLVE_URL}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ navigation_handle: navigationHandle }),
    });
    if (response.status === 401) {
      window.dispatchEvent(new Event('auth-expired'));
    }
    if (!response.ok) throw new Error('unavailable');
    const payload = await response.json();
    if (!payload || typeof payload.flow_id !== 'string' || !payload.flow_id) {
      throw new Error('unavailable');
    }
    return payload.flow_id;
  } catch {
    throw new Error('This workflow is no longer available.');
  }
}

/**
 * Keep the raw ID lifetime to this closed navigation adapter: resolve it and
 * immediately call App's existing selection function. Home Chat state, cards,
 * transcript, and modal props continue to contain opaque handles only.
 */
export async function navigateFromHomeChat(
  navigationHandle: string,
  selectFlow: (flowId: string) => Promise<void> | void,
): Promise<void> {
  const flowId = await resolveHomeChatNavigation(navigationHandle);
  await selectFlow(flowId);
}
